import { useActiveOrgId } from '~/hooks/org/useActiveOrgId'
import { useOrgGas } from '~/hooks/org/useOrgGas'
import { useGasAlertDismissStore } from '~/store/gasAlertDismissStore'

// The gas alert band to show app-wide, unless it was dismissed recently.
export const useGasAlert = () => {
  const orgId = useActiveOrgId()
  const { alert, fetchedAt } = useOrgGas()
  const dismissed = useGasAlertDismissStore((state) =>
    orgId ? state.dismissed[orgId] : undefined,
  )
  const isDismissed =
    !!dismissed && dismissed.kind === alert && dismissed.until > fetchedAt
  return alert && !isDismissed ? alert : null
}
